import React from 'react';

const Divider = () => <div className="ws-my-navbar__divider" />;

export default Divider;
